var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 23C30.9999 25 27.4182 30 23 30C18.5817 30 15 25 15 23C15 18.5816 18.5817 15 23 15C27.4182 15 30.9999 18.5816 30.9999 23Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 23C30.9999 27.4183 27.4182 31 23 31C18.5817 31 15 27.4183 15 23",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4785 30.0713L33.5995 27.9503L35.0135 29.3643L32.8925 31.4853L31.4785 30.0713Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9434 33.6064L30.0643 31.4855L31.4783 32.8995L29.3574 35.0205L27.9434 33.6064Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7207 34.3135L37.8417 32.1925L39.2557 33.6065L37.1347 35.7275L35.7207 34.3135Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1855 37.8486L34.3065 35.7277L35.7205 37.1417L33.5996 39.2626L32.1855 37.8486Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5996 32.1924L35.7206 30.0714L37.1346 31.4854L35.0136 33.6064L33.5996 32.1924Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0645 35.7275L32.1854 33.6066L33.5994 35.0206L31.4785 37.1415L30.0645 35.7275Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7305 15.9326L30.0745 10.2766L31.4885 8.86264L37.1445 14.5186L35.7305 15.9326Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0742 14.5186L27.9532 12.3976L29.3672 10.9836L31.4882 13.1046L30.0742 14.5186Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6094 18.0547L31.4884 15.9337L32.9023 14.5198L35.0233 16.6407L33.6094 18.0547Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3145 10.2764L32.1935 8.15539L33.6075 6.74138L35.7285 8.86236L34.3145 10.2764Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8516 13.8125L35.7306 11.6915L37.1446 10.2775L39.2656 12.3985L37.8516 13.8125Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1543 32.1885L13.8103 37.8444L12.3963 39.2585L6.74029 33.6025L8.1543 32.1885Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 33.6016L15.9296 35.7225L14.5156 37.1365L12.3947 35.0155L13.8086 33.6016Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2734 30.0674L12.3944 32.1884L10.9804 33.6024L8.85943 31.4814L10.2734 30.0674Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3945 27.9453L18.0505 33.6013L16.6365 35.0153L10.9805 29.3593L12.3945 27.9453Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8086 8.15137L8.15263 13.8073L6.73862 12.3933L12.3946 6.73736L13.8086 8.15137Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9297 10.2715L10.2737 15.9275L8.85971 14.5134L14.5157 8.85748L15.9297 10.2715Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0527 12.3936L12.3968 18.0495L10.9828 16.6356L16.6388 10.9796L18.0527 12.3936Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.5564d8c058c2588442da051f736d938b.svg";
export { ForwardRef as ReactComponent };